export default __webpack_public_path__ + "static/media/BANANA-SUSHI-BNB.6c6d57a9.svg";